module.exports = __webpack_public_path__ + "media/images/pc/stores/sola/how-to-enjoy-sola-04-d1e5b490d847025fb93f862e92f5682f.jpg";